// ENTITY com.ic2.entity.UserRight generated by ic2 4.0.0-SNAPSHOT at Thu Oct 01 15:16:31 UTC 2026

import { mapping, fields } from '@ic2/ic2-lib';

export class UserRight {

  static readonly __ic2_fqn: string = 'com.ic2.entity.UserRight';

  idUserRight: number | null = 0;
  idUser: number | null = 0;
  idRight: number | null = 0;

  constructor(init?:Partial<UserRight>) {
    Object.assign(this, init);
  }

  toString() {
    return JSON.stringify(this);
  }

}

mapping['com.ic2.entity.UserRight'] = UserRight;

fields['com.ic2.entity.UserRight']  = {
    idUserRight: 'java.lang.Integer',
    idUser: 'java.lang.Integer',
    idRight: 'java.lang.Integer'
};
